import script from "./HotSalesSide.vue?vue&type=script&lang=ts&setup=true"
export * from "./HotSalesSide.vue?vue&type=script&lang=ts&setup=true"

import "./HotSalesSide.vue?vue&type=style&index=0&id=6fbfa550&lang=css&scoped=true"
import "./HotSalesSide.vue?vue&type=style&index=1&id=6fbfa550&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fbfa550"]])

export default __exports__